import {
  IPromoDetail,
  IPromoDetailRepository,
  IPutPromoStatusParams,
} from "@/core/repositories/promotion/IPromoDetail.repository";

export class PutPromoStatusUseCase {
  constructor(private readonly repo: IPromoDetailRepository) {}

  async execute(params: IPutPromoStatusParams): Promise<IPromoDetail> {
    return this.repo.putPromoStatus(params);
  }
}
